export const initMetrics = (GTM, callback) => {
  (function(w, d, s, l, i) {
    w[l] = w[l] || []
    // eventCallback вызывается для каждого контейнера в приложении. В данном случае для gtag и gtm 
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js', eventCallback: (containerID) => {
      try {
        var tracker = window.ga.getAll()[0]
        var clientId = tracker.get('clientId')
        window.ClientId = clientId ? clientId : null
      } catch (e) {
        console.log('Ошибка получения Client ID')
      }
      if (GTM === containerID) {
        window.amplitude.getInstance().init(process.env.REACT_APP_AMPLITUDE_ID, clientId, {}, callback)
      }
    }})
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l !== 'dataLayer' ? '&l=' + l : ''
    j.async = true
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
    f.parentNode.insertBefore(j, f)
  })(window, document, 'script', 'dataLayer', GTM)
}
